import {
  ACCOUNT_TYPE,
  TypeOfRetirementAccount,
} from '../Steps/TypeOfRetirementAccount/TypeOfRetirementAccount';
import { BIRTH_DATE, YourDateOfBirth } from '../Steps/YourDateOfBirth/YourDateOfBirth';
import {
  TOTAL_INVESTABLE_ASSETS,
  TotalValueInvestableAssets,
} from '../Steps/TotalValueInvestableAssets/TotalValueInvestableAssets';
import {
  HOW_MUCH_SAVED,
  HowMuchSavePerMonth,
} from '../Steps/HowMuchSavePerMonth/HowMuchSavePerMonth';
import { StepKey, StepMap, ValidationPerStep } from './RetirementWorkflow.types';
import {
  SimpleIraPlanName,
  SIMPLE_IRA_PLAN_NAME,
} from '../Steps/SimpleIraPlanName/SimpleIraPlanName';
import { AccountTypeOptionsDTO } from '../../api/useAutomatedAccountsQuery';

export const FIELD_NAME = {
  [ACCOUNT_TYPE]: ACCOUNT_TYPE,
  [SIMPLE_IRA_PLAN_NAME]: SIMPLE_IRA_PLAN_NAME,
  [BIRTH_DATE]: BIRTH_DATE,
  [TOTAL_INVESTABLE_ASSETS]: TOTAL_INVESTABLE_ASSETS,
  [HOW_MUCH_SAVED]: HOW_MUCH_SAVED,
};

export const DEFAULT_VALUES = {
  [FIELD_NAME.accountType]: null,
  [FIELD_NAME.simplePlanName]: '',
  [FIELD_NAME.birthDate]: '',
  [FIELD_NAME.totalInvestableAssets]: null,
  [FIELD_NAME.howMuchSaved]: null,
};

export const VALIDATION_PER_STEP = {
  [StepKey.SimpleIraPlanName]: [FIELD_NAME.simplePlanName],
  [StepKey.Birthday]: [FIELD_NAME.birthDate],
  [StepKey.TotalInvestableAssets]: [FIELD_NAME.totalInvestableAssets],
  [StepKey.HowMuchSaved]: [FIELD_NAME.howMuchSaved],
} as ValidationPerStep;

export const STEPS_MAP = {
  [StepKey.AccountType]: () => TypeOfRetirementAccount,
  [StepKey.SimpleIraPlanName]: ({ accountType }) =>
    accountType === AccountTypeOptionsDTO.SimpleIRA ? SimpleIraPlanName : null,
  [StepKey.Birthday]: () => YourDateOfBirth,
  [StepKey.TotalInvestableAssets]: () => TotalValueInvestableAssets,
  [StepKey.HowMuchSaved]: () => HowMuchSavePerMonth,
} as StepMap;
